import { useEffect } from 'react';
import isNil from 'lodash/isNil';
import isNumber from 'lodash/isNumber';
type PropsT = {
  videoElement: HTMLVideoElement | null;
  src: string;
  currentFrame: number | null;
  getTimeFromFrameNumber: ((frame: number) => number) | null;
};

// This hook updates the video's current time to match the currentFrame whenever
// it changes, specifically for scenarios where the video is displayed in paused
// mode (e.g., for thumbnails).
export function useSeekOnFrameChange({
  videoElement,
  src,
  currentFrame,
  getTimeFromFrameNumber
}: PropsT) {
  useEffect(() => {
    if (!videoElement || !videoElement.paused) {
      return;
    }
    if (isNil(currentFrame) || !isNumber(currentFrame)) {
      return;
    }
    if (!getTimeFromFrameNumber) {
      return;
    }
    const currentTime = getTimeFromFrameNumber(currentFrame);
    if (isNumber(currentTime)) {
      // eslint-disable-next-line react-hooks/immutability
      videoElement.currentTime = (currentTime as number);
    }
    // Including `src` in the dependency array ensures the video seeks to the correct frame
    // whenever the source changes, restoring the last known frame position.
  }, [currentFrame, getTimeFromFrameNumber, videoElement, src]);
}